import _hashClear_default from "./_hashClear.js";
import _hashDelete_default from "./_hashDelete.js";
import _hashGet_default from "./_hashGet.js";
import _hashHas_default from "./_hashHas.js";
import _hashSet_default from "./_hashSet.js";

//#region ../../node_modules/lodash-es/_Hash.js
/**
* Creates a hash object.
*
* @private
* @constructor
* @param {Array} [entries] The key-value pairs to cache.
*/
function Hash(entries) {
	var index = -1, length = entries == null ? 0 : entries.length;
	this.clear();
	while (++index < length) {
		var entry = entries[index];
		this.set(entry[0], entry[1]);
	}
}
Hash.prototype.clear = _hashClear_default;
Hash.prototype["delete"] = _hashDelete_default;
Hash.prototype.get = _hashGet_default;
Hash.prototype.has = _hashHas_default;
Hash.prototype.set = _hashSet_default;
var _Hash_default = Hash;

//#endregion
export { _Hash_default as default };
//# sourceMappingURL=_Hash.js.map